
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation('common');

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/1c1efe20ab982279d0e71dac7f6c0a80/be3e2ad8bfbf737f34aa56acba3ac738.jpeg"
          alt="Luxury Home Interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-[#8B9B7E] font-medium mb-6 text-sm tracking-wider uppercase">
            {t('hero.badge')}
          </p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white mb-8 leading-tight">
            {t('hero.title')}
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto">
            {t('hero.subtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="bg-[#8B9B7E] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#7a8a6d] transition-all text-lg whitespace-nowrap cursor-pointer"
            >
              {t('hero.exploreServices')}
            </button>
            <button
              onClick={() => scrollToSection('packages')}
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#2B2B2B] transition-all text-lg whitespace-nowrap cursor-pointer"
            >
              {t('hero.viewPackages')}
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
